import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRemoveDiscussion(
  state: State,
  discussion: Boundaries["removeDiscussion"]["success"],
): State {
  return state.map((result) => ({
    ...result,
    discussions: result.discussions.filter(
      ({ uuid }) => uuid !== discussion.uuid,
    ),
  }));
}

export { handleRemoveDiscussion };
